<template>
  <div>
    <el-dialog title="系统公告" width="610px" 
      :close-on-click-modal="false"
      custom-class="system-dialog"
      :before-close="handleClose"   
      :visible.sync="visible"> 
      <div class="notice-box">
        <div class="title">指定号码发送&变量短信发送功能下线通知</div>
        <div>尊敬的商家朋友：</div>
        <div>因京东官方要求，软件内不支持提供商家上传手机号码发送短信的功能，【指定号码发送】、【变量短信发送】功能将于<span style="color: #FE4D45">7月9日</span>下线，其他功能均不受影响。</div>
        <div>给您带来不便敬请谅解，感谢您的支持与理解！</div>
        <div>如有疑问或需求可联系专属顾问/客服。</div>
        <div class="btn-wrap"><el-button type="primary" @click="handleClose">我知道了</el-button></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "notice",
  data() {
    return {
      visible: true
    }
  },
  mounted() {
  },
  methods: {
    handleClose() {
      // this.visible = false;
      this.$emit('close')
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-box {
 
  line-height: 18px;
  padding: 0 20px 25px 20px;
  font-size: 14px; 
  .title{
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 25px;
    color: #333;
  }
  div{
    margin-bottom: 15px;
    color: #777;
  }
  .btn-wrap{
    text-align: center;
    margin-top: 40px;
  }
}
</style>